/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Sales_HeadInputs */

const en_wb_sales_head = /** @type {(inputs: Wb_Sales_HeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reply draft`)
};

const lv_wb_sales_head = /** @type {(inputs: Wb_Sales_HeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atbildes melnraksts`)
};

/**
* | output |
* | --- |
* | "Reply draft" |
*
* @param {Wb_Sales_HeadInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_sales_head = /** @type {((inputs?: Wb_Sales_HeadInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Sales_HeadInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_sales_head(inputs)
	return en_wb_sales_head(inputs)
});